export const environment = {
	production: true,
	name:'preprod',
	apiWalletUrl: window["env"]["apiWalletUrl"] || "https://api-wallet.oandb.fr",
	apiUrl: 'https://api.v4.oandb.eu'
};
